export const ALL = "all"
export const ALL_TEXT = "All Type"
export const TODAY = "0"
export const YESTERDAY = "1"
export const A_WEEK = "7"
export const A_HALF_MONTH = "15"
export const A_MONTH = "30"

export const depositStatus = [
    { value: ALL, name: "All Status" },
    { value: "PENDING", name: "Pending" },
    { value: "COMPLETED", name: "Completed" },
    { value: "CANCELED", name: "Canceled" },
    { value: "TIMEOUT", name: "Timeout" },
]

export const withdrawStatus = [
    { value: ALL, name: "All Status" },
    { value: "under_review", name: "Under Review" },
    { value: "paying", name: "Paying" },
    { value: "completed", name: "Completed" },
    { value: "canceled", name: "Canceled" },
    { value: "timeout", name: "Timeout" },
]

export const bonusStatus = [
    { value: ALL, name: "All Type" },
    { value: "4001", name: "Mystery Box" },
    { value: "4003", name: "Level Up Bonus" },
    { value: "4004", name: "Birthday Bonus" },
]

export const timeRangeOptions = [
    { value: TODAY, name: "Today" },
    { value: YESTERDAY, name: "Yesterday" },
    { value: A_WEEK, name: "Last 7 days" },
    { value: A_HALF_MONTH, name: "Last 15 days" },
    { value: A_MONTH, name: "Last 30 days" },
]
